import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Slider } from '@/components/ui/slider';
import { Search } from 'lucide-react';

interface FlexEHistoryFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  successRateRange: [number, number];
  onSuccessRateChange: (value: [number, number]) => void;
  onlyFailed: boolean;
  onOnlyFailedChange: (value: boolean) => void;
}

export default function FlexEHistoryFilters({
  searchQuery,
  onSearchChange,
  successRateRange,
  onSuccessRateChange,
  onlyFailed,
  onOnlyFailedChange
}: FlexEHistoryFiltersProps) {
  return (
    <div className="space-y-4 p-4 bg-muted/30 rounded-lg border">
      {/* Search */}
      <div className="space-y-2">
        <Label htmlFor="search" className="text-sm font-medium">
          Zoeken
        </Label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            id="search"
            type="text"
            placeholder="Zoek op naam..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9"
          />
        </div>
      </div>

      {/* Success Rate Range */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <Label className="text-sm font-medium">Success Rate</Label>
          <span className="text-sm text-muted-foreground">
            {successRateRange[0]}% - {successRateRange[1]}%
          </span>
        </div>
        <Slider
          min={0}
          max={100}
          step={5}
          value={successRateRange}
          onValueChange={(value) => onSuccessRateChange(value as [number, number])}
          className="w-full"
        />
      </div>

      {/* Only Failed Toggle */}
      <div className="flex items-center justify-between">
        <Label htmlFor="only-failed" className="text-sm font-medium cursor-pointer">
          Alleen gefaalde simulaties (&lt;95%)
        </Label>
        <Switch
          id="only-failed"
          checked={onlyFailed}
          onCheckedChange={onOnlyFailedChange}
        />
      </div>
    </div>
  );
}
